// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import ScreenTitle from 'components/ScreenTitle';
import Header from 'components/Header';
import Footer from 'components/Footer';

const SupplierLayout = ({ children, title }) => {

	return (
		<div className='SupplierLayout'>
			
			<Header/>

			<Container>

				<ScreenTitle title={title}/>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

SupplierLayout.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string
}

SupplierLayout.defaultProps = {
	children: null,
	title: ''
}

export default SupplierLayout